<div class="modal-header">
    <h5 class="modal-title">Kategori Ekle</h5>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <form [formGroup]="categoryForm" (ngSubmit)="onSumbit()">
        <div class="mb-3">
            <label class="form-label">Kategori Adı</label>
            <input type="text" class="form-control" formControlName="name" placeholder="Kategori adını giriniz">
            <div *ngIf="categoryForm.get('name')?.touched && categoryForm.get('name')?.invalid"
                class="text-danger mt-1 small">
                Kategori adı zorunludur.
            </div>
        </div>
        <div [ngClass]="data.kindId != null ? 'ng-select-disabled' : ''">
            <label class="form-label">Türler</label>
            <ng-select [items]="kinds" bindLabel="typeName" bindValue="id" formControlName="kindId"
                [disabled]="data.kindId != null" placeholder="Kind seçiniz">
            </ng-select>
            <div *ngIf="categoryForm.get('kindId')?.touched && categoryForm.get('kindId')?.invalid"
                class="text-danger mt-1 small">
                Tür seçilmelidir.
            </div>
        </div>
    </form>

    <div *ngIf="data.kindId && categories?.length > 0" class="mt-4">
        <h6>Mevcut Kategoriler</h6>
        <table class="table table-bordered table-striped">
            <thead>
                <tr>
                    <th>Adı</th>
                    <th style="width:120px;">İşlemler</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let cat of categories">
                    <td>{{ cat.categoryName }}</td>
                    <td>
                        <div class="row">
                            <button class="btn btn-sm btn-flat-warning me-1" (click)="editCategory(cat)"><span
                                    data-feather="edit"></span></button>
                            <button class="btn btn-sm btn-flat-danger" appDelete controller="Categories" [id]="cat.id" (callback)="getAllCategory()"><span
                                    data-feather="trash"></span></button>

                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="activeModal.dismiss()">İptal</button>
    <button type="button" class="btn btn-primary" [disabled]="categoryForm.invalid" (click)="onSumbit()">Kaydet</button>
</div>